import { updateClasses } from './middlewares/settings.middleware.js';
import { updateTheme } from './middlewares/themes.middleware.js';

const STORAGE_KEY = 'recrutai-store-state';

/**
 * Use this function if you need to call a middleware
 * when setting the initial state.
 */
const callMiddlewares = (state) => {
  // Since a middlwrare is requried to modify the DOM in this case
  // for settings and themes, is necessary to call middleware
  // directly to set the initial state loaded from storage
  updateClasses(state);
  updateTheme(state);
};

/* Use an IIFE to export the persisted state in a variable */
export const persistedState = (() => {
  try {
    const rawState = localStorage.getItem(STORAGE_KEY);
    if (rawState === null) return undefined;
    const state = JSON.parse(rawState);

    delete state.accountInfo;
    delete state.companyTree;
    delete state.applicantTags;
    delete state.jobTags;
    delete state.identityDocs;
    delete state.industries;
    delete state.linkedinIndustries;
    delete state.countries;
    delete state.jobs;
    delete state.requests;
    delete state.user;
    delete state.planInfo;
    callMiddlewares(state);
    return state;
  } catch (err) {
    return undefined;
  }
})();

/**
 * Persist only UI preferences. Deep-cloning companyTree/tags/industries on every
 * Redux dispatch blocked the main thread for ~10–30s on large accounts (localhost
 * Network Finish ~35s with individually fast XHRs and long waterfall gaps).
 */
export const saveState = (state) => {
  try {
    if (!state || !state.settings) return;

    const settings = { ...state.settings };
    ['offsidebarOpen', 'asideToggled', 'horizontal'].forEach((item) => {
      delete settings[item];
    });

    const toSave = {
      settings,
      theme: state.theme
    };

    localStorage.setItem(STORAGE_KEY, JSON.stringify(toSave));
  } catch (err) {
    // Ignore write errors.
  }
};
